import React from "react";
import { Box, Grid } from "@mui/material";
import {
  PhonePreview,
  OsToggle,
  SegmentCalculation,
} from "@tiny/sms/src/widgets";
import MessageEditorPanel from "./MessageEditorPanel";

export interface MessageStepProps {
  smsText: string;
  onChange: (value: string) => void;
  calculation?: SegmentCalculation;
  calculationLoading?: boolean;
  senderNumber?: string;
}

function MessageStep(props: MessageStepProps) {
  const { smsText, onChange, calculation, calculationLoading, senderNumber } =
    props;
  const [os, setOs] = React.useState<"ios" | "android">("ios");

  return (
    <Box sx={{ maxWidth: 1090, margin: "0 auto", padding: "32px 24px" }}>
      <Grid container spacing={8}>
        <Grid item md={7} xs={12}>
          <MessageEditorPanel
            body={smsText}
            onBodyChange={onChange}
            calculation={calculation}
            calculationLoading={calculationLoading}
            senderNumber={senderNumber}
          />
        </Grid>
        <Grid
          item
          md={5}
          xs={12}
          display="flex"
          flexDirection="column"
          alignItems="center"
        >
          <Box mb={3}>
            <OsToggle value={os} onChange={setOs} />
          </Box>
          <PhonePreview os={os} message={smsText} senderNumber={senderNumber} />
        </Grid>
      </Grid>
    </Box>
  );
}

export default MessageStep;
